import {
  QuestionCategoryModel,
  QuestionCategorySendAttributes,
  QuestionCategoryContainQuestionTemplatesAttributes,
} from 'src/models/QuestionCategoryModel';
import { Notify } from 'quasar';
import { QuestionCategoryAdapterInteface } from 'src/adapter/QuestionCategoryAdapterInterface';
import { apiErrorHandler } from 'src/error/handler/apiErrorHandler';
export class QuestionCategoryApiClass {
  adapter: QuestionCategoryAdapterInteface;
  constructor(adapter: QuestionCategoryAdapterInteface) {
    this.adapter = adapter;
  }
  async getAllQuestionCategoriesContainQuestionTemplates(): Promise<
    QuestionCategoryContainQuestionTemplatesAttributes[]
  > {
    try {
      const res =
        await this.adapter.getAllQuestionCategoriesContainQuestionTemplates();
      if (res) {
        return res;
      }
      return [];
    } catch (e) {
      Notify.create({
        type: 'negative',
        message: '取得に失敗しました',
      });
      throw apiErrorHandler(e);
    }
  }
  async getQuestionCategory(id: string): Promise<QuestionCategoryModel> {
    try {
      const questionCategory = await this.adapter.getQuestionCategory(id);
      return new QuestionCategoryModel(questionCategory);
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async createQuestionCategory(
    attributes: QuestionCategorySendAttributes
  ): Promise<QuestionCategoryModel> {
    try {
      const questionCategory = await this.adapter.createQuestionCategory(
        attributes
      );
      return new QuestionCategoryModel(questionCategory);
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async updateQuestionCategory(
    id: string,
    attributes: QuestionCategorySendAttributes
  ): Promise<QuestionCategoryModel> {
    try {
      const questionCategory = await this.adapter.updateQuestionCategory(
        id,
        attributes
      );
      Notify.create({
        type: 'positive',
        message: '更新しました',
      });
      return new QuestionCategoryModel(questionCategory);
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async deleteQuestionCategory(id: string): Promise<boolean> {
    try {
      const res = await this.adapter.deleteQuestionCategory(id);
      Notify.create({
        type: 'positive',
        message: '削除しました',
      });
      return res;
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
}
